import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn, type RouterStateSnapshot } from '@angular/router';
import { NIASBizBllModelsDocumentAttachmentLoadModel, ReferentApiClientService } from '../api/v1';
import { map, of } from 'rxjs';
import { ScannedDocument } from '@fina-dot-net/ngf-attachments-list';

export const authDocImagesResolver: ResolveFn<ScannedDocument[] | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const referentApiService = inject(ReferentApiClientService);

  const attachementId = route.paramMap.get('id');

  if (attachementId == null) {
    return of(null);
  }

  return referentApiService.referentApiGetAttachedDocumentsForLegalEntity(attachementId).pipe(
    map((x) => {
      if (!x) {
        return null;
      }
      return x as any;
    })
  );
};
